import {
  AccountOwnerDetailResponse,
  PartnerType,
} from '@b7hio/api-lib/src/ops-portal';
import { FormAutocomplete } from '@b7hio/core-lib/src';
import { Box } from '@mui/system';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { VirtualTransactionListFilterValues } from './VirtualTransactionListFilter.validation';

const PartnerTypes = {
  BANK: 'BANK' as PartnerType,
  PLATFORM: 'PLATFORM' as PartnerType,
  CUSTOMER: 'CUSTOMER' as PartnerType,
};

interface Props {
  readonly banksList: readonly AccountOwnerDetailResponse[];
  readonly customerList: readonly AccountOwnerDetailResponse[];
  readonly platformList: readonly AccountOwnerDetailResponse[];
}

export const VirtualTransactionListFilter = ({
  banksList,
  customerList,
  platformList,
}: Props): JSX.Element => {
  const { t } = useTranslation(['common', 'transactions']);
  const { control, watch } =
    useFormContext<VirtualTransactionListFilterValues>();

  const accountPartnerType = watch('partnerType');

  const accountPartnerTypes = Object.values(PartnerTypes).map((value) => ({
    value: value,
    label: t(`common:partnerType.${value}`),
  }));

  const bankProductsList = banksList.map((response) => ({
    value: response.accountOwnerUid,
    label: response.accountOwnerName ? response.accountOwnerName : 'Unknown',
  }));

  const customers = customerList.map((response) => ({
    value: response.accountOwnerUid,
    label: response.accountOwnerName ? response.accountOwnerName : 'Unknown',
  }));

  const platforms = platformList.map((response) => ({
    value: response.accountOwnerUid,
    label: response.accountOwnerName ? response.accountOwnerName : 'Unknown',
  }));

  return (
    <>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(256px, min-content))',
          gap: '5px',
        }}>
        <FormAutocomplete
          name="partnerType"
          test-id="partnerType"
          label={t('transactions:filter.partnerType')}
          t={t}
          control={control}
          options={accountPartnerTypes}
          size="small"
        />
        {accountPartnerType === PartnerType.PLATFORM && (
          <FormAutocomplete
            name="platform"
            test-id="platform"
            label={t('transactions:filter.platform')}
            t={t}
            control={control}
            options={platforms}
            size="small"
          />
        )}
        {accountPartnerType === PartnerType.BANK && (
          <FormAutocomplete
            name="bank"
            test-id="bank"
            label={t('transactions:filter.bankProduct')}
            t={t}
            control={control}
            options={bankProductsList}
            size="small"
          />
        )}
        {accountPartnerType === PartnerType.CUSTOMER && (
          <FormAutocomplete
            name="customer"
            test-id="customer"
            label={t('transactions:filter.customer')}
            t={t}
            control={control}
            options={customers}
            size="small"
          />
        )}
      </Box>
    </>
  );
};
